import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

function AddButton() {
  const popover = (
    <Popover id="popover-basic">
      <div className="px-2 py-1 fw-semibold">Post your Pitch</div>
    </Popover>
  );

  return (
    <>
      <OverlayTrigger placement="top" overlay={popover}>
        {({ ref, ...triggerHandler }) => (
          <button
            {...triggerHandler}
            className=" addbtn d-flex align-items-center justify-content-center"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            <div ref={ref} roundedCircle className="fs-1 d-flex mb-0 mb-md-2">
              {" "}
              <span>+</span>
            </div>
          </button>
        )}
      </OverlayTrigger>
    </>
  );
}

export default AddButton;
